<info-page>
  <ng-template #image><img alt="" src="/assets/images/unauthorized-401.svg" /></ng-template>
  <ng-template #title>Redirecting...</ng-template>
  <ng-template #description>This page is accessible only for logged in users</ng-template>
</info-page>
